import { Alert } from '@chakra-ui/react';
import React from 'react';

import type { SmartContract } from 'types/api/contract';

import { useI18n } from 'lib/i18n/context';
import LinkExternal from 'ui/shared/links/LinkExternal';

import { ADDRESS_CONTRACT_KEYS } from '../../i18n';

interface Props {
  data: SmartContract | undefined;
}

const ContractDetailsAlertVerificationSource = ({ data }: Props) => {
  const { t } = useI18n();

  if (data?.is_verified_via_eth_bytecode_db) {
    const textKey = data.is_partially_verified ?
      ADDRESS_CONTRACT_KEYS.notice.bytecodeDbPartiallyVerified :
      ADDRESS_CONTRACT_KEYS.notice.bytecodeDbVerified;

    return (
      <Alert status="warning" whiteSpace="pre-wrap" flexWrap="wrap" borderRadius="8px">
        <span>{ t(textKey) } </span>
        <LinkExternal
          href="https://docs.blockscout.com/about/features/ethereum-bytecode-database-microservice"
          fontSize="md"
        >
          Blockscout Bytecode Database
        </LinkExternal>
      </Alert>
    );
  }

  if (data?.is_verified_via_sourcify) {
    const textKey = data.is_partially_verified ?
      ADDRESS_CONTRACT_KEYS.notice.sourcifyPartiallyVerified :
      ADDRESS_CONTRACT_KEYS.notice.sourcifyVerified;

    return (
      <Alert status="warning" whiteSpace="pre-wrap" flexWrap="wrap" borderRadius="8px">
        <span>{ t(textKey) } </span>
        { data.sourcify_repo_url && (
          <LinkExternal href={ data.sourcify_repo_url } fontSize="md">{ t(ADDRESS_CONTRACT_KEYS.security.viewSourcify) }</LinkExternal>
        ) }
      </Alert>
    );
  }

  return null;
};

export default React.memo(ContractDetailsAlertVerificationSource);
